export const Marquee = ({
  items = [],
  className = "",
  textClassName = "text-ss-text",
}) => {
  const content = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden whitespace-nowrap border-y border-ss-gold/15 bg-ss-bgAlt py-5 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {content.map((item, i) => (
          <span
            key={i}
            className={`font-heading font-semibold text-2xl sm:text-3xl mx-6 flex items-center gap-6 [-webkit-text-stroke:1px_#D4AF37] text-transparent ${textClassName}`}
          >
            {item}
            <span className="text-ss-terracotta [-webkit-text-stroke:0] text-base">
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
